/*
 * @Author       : LiYang
 * @Date         : 2021-05-08 10:12:51
 * @LastEditTime : 2021-12-23 21:07:49
 * @LastEditors  : Please set LastEditors
 * @Description  : FP
 */


const kestrel = (a, b) => (...res)=> a.apply(null, res).then(b)

export const serial = (...fns) => {
  if (!fns.length) throw new Error('pipe requires one or more arguments');
  const args = Array.isArray(fns[0])
    ? fns[0]
    : [].slice.apply(fns);
  return args.slice(1).reduce(kestrel, args[0]);
}

export const compose = (...arg) => arg.reduce((a, b) => (...args) => a(b(...args)))

export const pipe = (...arg) => arg.reduce((a, b) => (...args) => b(a(...args)))

export const curry = (arity, fn) => {
  const curried = (arg) => (...newArg) => {
    const all = arg.concat(newArg)
    return all.length < arity ? curried(all) : fn(...all)
  }
  return curried([])
}

export const when = curry(3, (pred, whenTrueFn, val) => pred(val) ? whenTrueFn(val) : val)

export const ifElse = (conditions, onTrue, onFlase) => curry(
  Math.max(conditions.length, onTrue.length, onFlase.length),
  (...res) => conditions(...res) ? onTrue(...res) : onFlase(...res)
)

export const cond = (pairs) => (...res) => {
  let idx = 0
  while (idx < pairs.length) {
    if (pairs[idx][0](...res)) {
      return pairs[idx][1](...res)
    }
    idx++
  }
}

export function partial () {
  const args = [].slice.call(arguments)
  const fn = args.shift()
  return function () {
    let idx = args.length
    const len = arguments.length

    for (let i = 0; i < len; i++) {
      args[idx++] = arguments[i]
    }
    return fn.apply(this, args)
  }
}


/**
 * @method 通过UA获取app版本号
 * @returns {String}
 */
 export function getAppVersionByUA () {
  const ddWebView = window && window.navigator && /didies/.test(window.navigator.userAgent)
  console.log('ddWebView =========> ', ddWebView);
  if (!ddWebView) {
    return ''
  }
  const ua = window.navigator.userAgent
  console.log('ua ========> ', ua);
  const appV = ua.match(/didies\/(\d+(\.\d+)*)/)[1]
  console.log(appV, 'appv');
  return appV
}

/**
 * @method 版本号比较
 * @param {String} v1
 * @param {String} v2
 * @returns {Number} v1 < v2: -1;  v1 = v2: 0;  v1 > v2: 1
 */
 export function compareVersion (v1, v2) {
  // 将两个版本号拆成数组
  let arr1 = v1.split('.'),
      arr2 = v2.split('.');
  let minLength = Math.min(arr1.length,arr2.length);
  // 依次比较版本号每一位大小
  for (var i = 0; i < minLength; i++) {
      if (parseInt(arr1[i]) != parseInt(arr2[i])) {
          return (parseInt(arr1[i]) > parseInt(arr2[i])) ? 1 : -1;
      }
  }
  // 若前几位分隔相同，则按分隔数比较。
  if (arr1.length == arr2.length) {
      return 0;
  } else {
      return (arr1.length > arr2.length) ? 1 : -1;
  }
}

/**
 * @method app版本大于等于目标版本
 * @param {*} v 要比较的目标版本
 * @returns {Boolean} true 大于目标版本 false 小于目标版本
 */
export function versionValid (v = '3.3.2') {
  const curV = getAppVersionByUA()
  console.log(curV, 'curV', v, 'v');
  if (!curV) {
    return false
  }
  return compareVersion(curV, v) >= 0
}
